const state = {
  data: [],
  needReload: false,
  param: {
    filter: {},
    sort: [{ field: "attachNo", order: "DESC" }],
  },
  totalPages: 0,
  totalCount: 0,
  selectedNoArray: [],
  inputValues: {},
};

const actions = {
  CHANGE_FILTER: ({ commit }, payload) => {
    commit('MUTATION_CHANGE_FILTER', payload);
  },
  GET_ATTACH_FILE: ({ commit }, params) => {
    commit("MUTATION_GET_ATTACH_FILE", params);
  },
  UPLOAD_ATTACH_FILE: ({ commit }, params) => {
    commit("MUTATION_UPLOAD_ATTACH_FILE", params);
  },
  UPDATE_ATTACH_FILE: ({ commit }, params) => {
    commit("MUTATION_UPDATE_ATTACH_FILE", params);
  },
  DELETE_ATTACH_FILE: ({ commit }, params) => {
    commit("MUTATION_DELETE_ATTACH_FILE", params);
  },
  SELECT_ATTACH_FILE: ({ commit }, params) => {
    commit("MUTATION_SELECT_ATTACH_FILE", params);
  },
  INIT_INPUT_VALUE: ({ commit }, params) => {
    commit("MUTATION_INIT_INPUT_VALUE", params);
  },
  SET_INPUT_VALUE: ({ commit }, params) => {
    commit("MUTATION_SET_INPUT_VALUE", params);
  },
};

const mutations = {
  MUTATION_CHANGE_FILTER: (state, payload) => {
    state["param"]["filter"] = payload;
  },
  MUTATION_GET_ATTACH_FILE: (state, payload) => {
    if (payload && payload.data) {
      const { list } = payload.data;
      const { offset, limit } = payload.config.params;
      const totalCount = list && list.length > 0 ? list[0].rnum + offset : 0;
      const totalPages = Math.ceil(totalCount / limit);
      state["data"] = list ? list : [];
      state["needReload"] = false;
      state["totalCount"] = totalCount;
      state["totalPages"] = totalPages;
      state["selectedNoArray"] = [];
    }
  },
  MUTATION_UPLOAD_ATTACH_FILE: (state, payload) => {
    state["needReload"] = true;
  },
  MUTATION_UPDATE_ATTACH_FILE: (state, payload) => {
    state["needReload"] = true;
  },
  MUTATION_DELETE_ATTACH_FILE: (state, payload) => {
    state["needReload"] = true;
  },
  MUTATION_SELECT_ATTACH_FILE: (state, payload) => {
    state["selectedNoArray"] = payload;
  },
  MUTATION_INIT_INPUT_VALUE: (state, payload) => {
    state["inputValues"] = {};
  },
  MUTATION_SET_INPUT_VALUE: (state, payload) => {
    Object.keys(payload).map((key) => {
      state["inputValues"][key] = payload[key];
    });
  },
};

const getters = {
  STATE: (state) => {
    return state;
  },
  GET_INPUT_VALUES: (state) => {
    return state.inputValues;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
